import { ProjectStatusType } from '@/types';

export interface StatusOption {
  value: ProjectStatusType;
  label: string;
}

export const PROJECT_STATUSES: StatusOption[] = [
  { value: 'planning', label: 'Planning' },
  { value: 'in progress', label: 'In Progress' },
  { value: 'on hold', label: 'On Hold' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'completed', label: 'Completed' },
];
